<div class="load-indicator-container">
    <svg class="spinnerDroplet" viewBox="0 0 29.31 40" xmlns="http://www.w3.org/2000/svg" >
      <defs>
        <style>
          .cls-1 {
            fill: #3a3b47;
          }
        </style>
      </defs>
      <title>Droplet</title>
      <g id="Lag_2" data-name="Lag 2">
        <g id="Lag_1-2" data-name="Lag 1">
          <path id="path4485" class="cls-1" d="M14.66,0,13.38,1.53s-3.25,3.92-6.56,8.8A66.17,66.17,0,0,0,2.19,18,17.31,17.31,0,0,0,0,25.34a14.66,14.66,0,1,0,29.31,0A17.17,17.17,0,0,0,27.12,18a66.17,66.17,0,0,0-4.63-7.69c-3.31-4.88-6.56-8.8-6.56-8.8Zm0,5.24a84.93,84.93,0,0,1,5.19,6.92,65.18,65.18,0,0,1,4.32,7.33,15.82,15.82,0,0,1,1.89,5.85,11.4,11.4,0,0,1-22.8,0,15.76,15.76,0,0,1,1.88-5.85,63.82,63.82,0,0,1,4.33-7.33,80.27,80.27,0,0,1,5.19-6.92Zm8.14,20.1H19.54a4.89,4.89,0,0,1-4.88,4.89v3.26a8.18,8.18,0,0,0,8.14-8.15Z"
          />
        </g>
      </g>
    </svg>
</div>